export const bannerTypeEnum = [
  {
    label: 'Chọn banner',
    key: ''
  },
  {
    label: 'Trang chủ',
    key: 'HOME_PAGE'
  },
  {
    label: 'Lịch sử',
    key: 'HISTORY'
  },
  {
    label: 'Phân đường',
    key: 'BRANCH'
  },
  {
    label: 'Kỹ thuật',
    key: 'TECHNIQUE'
  },
  {
    label: 'Hoạt động',
    key: 'OPERATION'
  },
  {
    label: 'Thư viện',
    key: 'LIBRARY'
  },
  {
    label: 'Bài viết',
    key: 'INFORMATION'
  },
  {
    label: 'Chia sẻ của thầy',
    key: 'TEACHER_SHARE'
  },
  {
    label: 'Liên hệ',
    key: 'CONTACT'
  },
  {
    label: 'Tìm kiếm',
    key: 'SEARCH'
  }
];
